var swiper=new Swiper(".mySwiper",
  {
    slidesPerView:2,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    spaceBetween:10,breakpoints:{640:{slidesPerView:2,spaceBetween:10},768:{slidesPerView:3,spaceBetween:30},1024:{slidesPerView:4,spaceBetween:30}},scrollbar:{draggable: true, el:".swiper-scrollbar",hide:!1}});
//# sourceMappingURL=/cdn/shop/t/136/assets/swiper-carousel.js.map
